import React, { Fragment, useEffect, useState } from 'react'
import { connect } from 'react-redux';
import Box from '@mui/material/Box';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Button from 'react-bootstrap/Button';
import Spinner from 'react-bootstrap/Spinner';
import { removeContact } from '../../../common/api';
import { toast } from 'react-toastify';

import '../modals.css';

const RemoveContact = ( { close, orgId, uid, c } ) => {
    const [ processing, setProcessing ] = useState( false );
    const [ trashing, setTrashing ] = useState( false );

    const trash = async () => {
        setProcessing( true );
        setTrashing( true );

        console.log( 'deleting: ', c );
        const removed = await removeContact( orgId, c.aid, uid, c.cid, ( c.shared === true ) ? true : false );
        if ( removed.length ) {
            toast.success( `${c.name} has been deleted`, { theme: 'dark' } );
            close();
        }
    }


    const style = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: '450px',
        bgcolor: 'background.paper',
        border: '1px solid #000',
        p: 2,
        maxHeight: '95vh',
        overflowY: 'auto'
    };

    return (
        <Fragment>
            <Box sx={ { ...style, pt: 0 } }>
                <Row className='py-2' style={ { borderBottom: '1px solid var( --bs-border-color )' } }>
                    <Col className='tf-modal-title'>About to Delete {c.name}</Col>
                </Row>
                {
                    processing ? (
                        <Fragment>
                            <Row className='py-3'>
                                <Col className='text-center'>
                                    <Spinner animation="border" variant='primary' role="status" />
                                </Col>
                            </Row>
                        </Fragment>
                    ) : (
                        <Container fluid>
                            <Row className='w-100 p-2 pt-4 align-items-center'>
                                <Col className='pe-2 text-center'><Button onClick={ trash } disabled={ trashing }>Yes, Delete</Button></Col>
                                <Col className='ps-2 text-center'><Button variant='outline-dark' onClick={close}>Cancel</Button></Col>
                            </Row>
                        </Container>
                    )
                }
            </Box>
        </Fragment>
    )
}

const mapProps = ( state ) => ( {
    orgId: state.user.orgId,
    uid: state.user.email
} );
  
const mapDispatch = ( dispatch ) => ( {
} );
  
export default connect( mapProps, mapDispatch )( RemoveContact );